export class Logger {
  public constructor(
    private isEnabled: boolean = import.meta.env.DEV || false,
  ) {}

  public error(...args: unknown[]): void {
    // always log errors
    console.error(...args);
  }

  public info(...args: unknown[]): void {
    if (this.isEnabled) {
      console.info(...args);
    }
  }

  public log(...args: unknown[]): void {
    if (this.isEnabled) {
      console.log(...args);
    }
  }

  public setEnabled(isEnabled: boolean): void {
    this.isEnabled = isEnabled;
  }

  public warn(...args: unknown[]): void {
    if (this.isEnabled) {
      console.warn(...args);
    }
  }
}
